import React from 'react';
import { Route, Routes } from 'react-router-dom';
import LandingPage from '../../pages/LandingPage';
import ClientForm from '../../pages/ClientSubmissionForm';
import OurServices from '../../pages/OurServices';
import AboutUs from '../../pages/AboutUs';
import OurExpertise from '../../pages/OurExpertise';
import AdvancedAI from '../../pages/AdvancedAI';
import BigData from '../../pages/BigData.js';
import DataLake from '../../pages/DataLake.js';
import DataWarehouse from '../../pages/DataWarehouse.js';
import AIDataScience from '../../pages/AIDataScience';
import AITextAnalysis from '../../pages/AITextAnalysis';
import AIComputerVision from '../../pages/AIComputerVision';
import AIPredictiveAnalysis from '../../pages/AIPredictiveAnalysis.js';
import GenerativeAI from '../../pages/GenerativeAI.js';
import DataAnalytics from '../../pages/DataAnalytics.js';
import DataIntegration from '../../pages/DataIntegration.js';
import Tableau from '../../pages/Tableau.js';
import PowerBI from '../../pages/PowerBI.js';
import ProductEngineering from '../../pages/ProductEngineering.js';
import Angular from '../../pages/Angular.js';
import Careers from '../../pages/Careers.js';
import AIML from '../../pages/AIML.js';
import ReactPage from '../../pages/React.js';
import PythonPage from '../../pages/Python.js';
import PrivacyPolicy from '../../pages/PrivacyPolicy.js';

const Navigator = () => {
  return (
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/clientForm" element={<ClientForm />} />
        <Route path="/ourservices" element={<OurServices />} />
        <Route path='/aboutus' element={<AboutUs />} />
        <Route path='/ourExpertise' element={<OurExpertise />} />
        <Route path='/AdvancedAI' element={<AdvancedAI />} />
        <Route path='/BigData' element={<BigData />} />
        <Route path='/DataLake' element={<DataLake />} />
        <Route path='/DataWarehouse' element={<DataWarehouse />} />
        <Route path='/DataIntegration' element={<DataIntegration />} />
        <Route path='/AI_DataScience' element={<AIDataScience />} />
        <Route path='/AI_TextAnalysis' element={<AITextAnalysis />} />
        <Route path='/AI_ComputerVision' element={<AIComputerVision />} />
        <Route path='/AI_PredictiveAnalysis' element={<AIPredictiveAnalysis />} />
        <Route path='/GenerativeAI' element={<GenerativeAI />} />
        <Route path='/DataAnalytics' element={<DataAnalytics />} />
        <Route path='/Tableau' element={<Tableau />} />
        <Route path='/PowerBI' element={<PowerBI/>}/>
        <Route path='/ProductEngineering' element={<ProductEngineering/>} />
        <Route path='/Angular' element={<Angular/>}/>
        <Route path='/Careers' element={<Careers/>}/>
        <Route path='/AIML' element={<AIML/>}/>
        <Route path='/Reactjs' element={<ReactPage/>}/>
        <Route path='/Python' element={<PythonPage/>}/>
        <Route path='/PrivacyPolicy' element={<PrivacyPolicy/>}/>
      </Routes>
  );
};

export default Navigator;
